export const PUBLIC_PATHS = {
  REGISTER: '/sign-up',
  LOGIN: '/login',
  FORGOT_PASS: '/forgot-password',
  CHANGE_PASSWORD: '/change-password',
  VERIFY_OTP: '/verify-otp',
  COMPANY_INFO: '/company-info',
  FINISH_SETUP: '/finish-setup',
} as const;

export const PRIVATE_PATHS = {
  DASHBOARD: '/dashboard',
  AGENCY_TALENTS: '/agency-talents',
  AGENCY_TALENTS_BASIC_INFO: '/agency-talents/basic-info',
  AGENCY_TALENTS_PERSONAL_INFO: '/agency-talents/professional-experience',
  AGENCY_TALENTS_INTRO_VIDEO: '/agency-talents/intro-video',
  AGENCY_TALENTS_PAY_SETTINGS: '/agency-talents/pay-settings',
  EDIT_TALENT_RESOLVER: '/agency-talents/edit/:id',
  EDIT_AGENCY_TALENT: '/agency-talents/edit/:id',
  UPDATE_AGENCY_TALENT: '/agency-talents/update/:id',
  VIEW_AGENCY_TALENT: '/agency-talents/view/:id',

  OFFERS: '/work-offers',
  WORK_STREAMS: '/work-streams',
  VIEW_STREAMS_DETAILS: '/work-streams/:id',
  REVIEWS: '/reviews',
  EARNINGS: '/earnings',
  CLIENTS: '/clients',
  CALLS: '/calls',
  CHATS: '/chats',
  SETTINGS: '/settings',
  PLANS: '/settings/tabs/Plans',
  CONFIRM_PLAN: '/settings/tabs/confirm-plan',
  COMPANY_DETAILS: '/settings/company-details',
  PUBLIC_PROFILE: '/settings/public-profile',
  PROFILE_SAVED: '/settings/profile-saved',
} as const;
